import type { Routes } from "@angular/router";
import { activateRoute } from "./activate/activate.route";
import {
    loginRoute,
    loginViaImpersonateRoute,
    oauthCallbackRoute,
    verifyTwoFactorRoute,
} from "./login/login.route";
import { passwordRoute } from "./password/password.route";
import { passwordResetFinishRoute } from "./password-reset/finish/password-reset-finish.route";
import { passwordResetInitRoute } from "./password-reset/init/password-reset-init.route";
import { settingsRoute } from "./settings/settings.route";

const ACCOUNT_ROUTES = [
    loginRoute,
    verifyTwoFactorRoute,
    loginViaImpersonateRoute,
    oauthCallbackRoute,
    activateRoute,
    passwordRoute,
    passwordResetFinishRoute,
    passwordResetInitRoute,
    settingsRoute,
];

export const accountState: Routes = [
    {
        path: "",
        children: ACCOUNT_ROUTES,
    },
];
